import LogoIcon from "../../assets/logo.svg";
import "./notfound.scss";

export default function NotFound() {
  return (
    <div id="not-found">
      <div className="not-found-header">

        <img className="branding-header-icon" src={LogoIcon} alt="sohm" />


        <h4>Page not found</h4>
      </div>
    </div>
  );
}
